import React from 'react';
import { Layout, Typography } from 'antd';
import MainTable from './MainTable.tsx';
import JobTrendLineGraph from './JobTrendLineGraph.tsx';

const {  Content } = Layout;
const { Title } = Typography;

const App: React.FC = () => {
  return (
    <Layout>
        <Title >ML Engineer Salaries</Title>
      <Content >
        <MainTable />
        <JobTrendLineGraph />
      </Content>
    </Layout>
  );
};

export default App;
